export enum TSSchadenfallStatus {
    NEU = <any>'NEU',
    NEU_PAPIER_ANLAUFSTELLE = <any>'NEU_PAPIER_ANLAUFSTELLE',
    NEU_PAPIER_FS = <any>'NEU_PAPIER_FS',
    IN_BEARBEITUNG_ANLAUFSTELLE = <any>'IN_BEARBEITUNG_ANLAUFSTELLE',
    IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS = <any>'IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS',
    AUFTRAG_SCHAETZER = <any>'AUFTRAG_SCHAETZER',
    UEBERPRUEFUNG_ANLAUFSTELLE = <any>'UEBERPRUEFUNG_ANLAUFSTELLE',
    UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS = <any>'UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS',
    UEBERPRUEFUNG_FONDSSUISSE = <any>'UEBERPRUEFUNG_FONDSSUISSE',
    WIEDERHERSTELLUNG = <any>'WIEDERHERSTELLUNG',
    UEBERPRUEFUNG_SCHAETZER = <any>'UEBERPRUEFUNG_SCHAETZER',
    SCHADEN_BEHOBEN_ABRECHNEN = <any>'SCHADEN_BEHOBEN_ABRECHNEN',
    AUSZAHLUNG = <any>'AUSZAHLUNG',
    ABGESCHLOSSEN = <any>'ABGESCHLOSSEN',
    ABGELEHNT_ANLAUFSTELLE = <any>'ABGELEHNT_ANLAUFSTELLE',
    ABGELEHNT_FONDSSUISSE = <any>'ABGELEHNT_FONDSSUISSE',
    IMPORTIERT = <any>'IMPORTIERT'
}

export function getTSSchadenfallStatusalues(): Array<TSSchadenfallStatus> {
    return [
        TSSchadenfallStatus.NEU,
        TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE,
        TSSchadenfallStatus.NEU_PAPIER_FS,
        TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE,
        TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS,
        TSSchadenfallStatus.AUFTRAG_SCHAETZER,
        TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE,
        TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS,
        TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE,
        TSSchadenfallStatus.WIEDERHERSTELLUNG,
        TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER,
        TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN,
        TSSchadenfallStatus.AUSZAHLUNG,
        TSSchadenfallStatus.ABGESCHLOSSEN,
        TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE,
        TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE,
    ];
}

export function getTSSchadenfallStatusOffen(): Array<TSSchadenfallStatus> {
    return [
        TSSchadenfallStatus.NEU,
        TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE,
        TSSchadenfallStatus.NEU_PAPIER_FS,
        TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE,
        TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS,
        TSSchadenfallStatus.AUFTRAG_SCHAETZER,
        TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE,
        TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS,
        TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE,
        TSSchadenfallStatus.WIEDERHERSTELLUNG,
        TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER,
        TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN,
        TSSchadenfallStatus.AUSZAHLUNG,
    ];
}

export function getTSSchadenfallStatusGeschlossen(): Array<TSSchadenfallStatus> {
    return [
        TSSchadenfallStatus.ABGESCHLOSSEN,
        TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE,
        TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE,
    ];
}

export function getTSSchadenfallStatusNeu(): Array<TSSchadenfallStatus> {
    return [
        TSSchadenfallStatus.NEU,
        TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE,
        TSSchadenfallStatus.NEU_PAPIER_FS,
    ];
}

/**
 * Returns true when the status of the Gesuch is Geschlossen
 * @returns {boolean}
 */
export function isStatusGeschlossen(status: TSSchadenfallStatus): boolean {
    return isInStatus(status, getTSSchadenfallStatusGeschlossen());
}

export function isInStatus(status: TSSchadenfallStatus, statusArray: Array<TSSchadenfallStatus>): boolean {
    for (let istatus of statusArray) {
        if (istatus === status) {
            return true;
        }
    }
    return false;
}






// WEBPACK FOOTER //
// ./src/app/models/enums/TSSchadenfallStatus.ts